// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { useCallback, useContext, useEffect, useState } from 'react';

import { endpoint } from '../config';
import { ZkidWalletContext } from '../ZkidWallet';
import { event } from './events';

export type Phase = [boolean, boolean, boolean, boolean];

export function usePhase(): Phase | undefined {
  const { didUrl } = useContext(ZkidWalletContext);
  const [phase, setPhase] = useState<Phase>();

  const fn = useCallback(() => {
    didUrl &&
      fetch(`${endpoint}/verify_status/${didUrl}`)
        .then((res) => res.json())
        .then((data) => {
          setPhase([data.phase0, data.phase1, data.phase2, data.phase3]);
        });
  }, [didUrl]);

  useEffect(() => {
    fn();

    event.on('phase_refresh', fn);

    return () => {
      event.off('phase_refresh', fn);
    };
  }, [fn]);

  return phase;
}
